import { type OrderData } from "~/domains/orders/types/modelsV2";
import { type DocumentListRow } from "~/features/orders/orderList/useOrderListState";

export const rowHasSurcharge = (row: DocumentListRow<OrderData>) => row.data.hasSurcharge;

export const getIsAllOpen = (rows: DocumentListRow<OrderData>[]) => rows.length > 0 && rows.every((item) => item.open);
